var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.isLoading)?_c('v-row',[_c('v-col',[_c('loading-spinner')],1)],1):_c('v-row',[_c('v-col',[_c('paginated-table',{attrs:{"title":_vm.$t('title.journal_publish_management'),"icon":"toc","columns":_vm.columns,"data":_vm.journals},on:{"updatePagination":_vm.updatePagination}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }